<script>
import {Line, mixins} from 'vue-chartjs'
import ChartAnnotations from 'chartjs-plugin-annotation';

const {reactiveProp} = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['startDate'],
    watch: {
      startDate() {
        this.reRenderChart();
      },
    },
    mounted() {
        this.addPlugin(ChartAnnotations);
        this.reRenderChart();
    },
    methods: {
      reRenderChart() {
        this.renderChart(this.chartData, {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 10
              }
            }]
          },
          elements: {
            line: {
              tension: 1
            }
          },
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'vertical',
              scaleID: 'x-axis-0',
              value: this.startDate,
              borderColor: '#00000040',
              borderWidth: 2,
              label: {
                enabled: true,
                content: 'Subscription period start',
                yAdjust: -150
              }
            }]
          }
        });
      }
    }
}
</script>

<style>
</style>
